import React from "react"
import { ListboxButton, ListboxArrow } from "@reach/listbox"
import clsx from "clsx"

import { Icon } from "../../icon"

function Button({ value, valueLabel, error, ...rest }) {
  return (
    <ListboxButton
      className={clsx(
        "body pb-px h-12 border bg-white transition-colors duration-150 focus:outline-none rounded pl-4 pr-2 text-mineralGray placeholder-gray placeholder-opacity-50 w-full",
        !error && "border-gray focus:border-mineralGray",
        error && "border-red text-red"
      )}
      {...rest}
    >
      <span data-value={value} className="truncate">
        {valueLabel}
      </span>
      <ListboxArrow>
        <div className="flex items-center justify-center w-8 h-8">
          <Icon
            aria-hidden
            className="text-violet"
            symbol="chevron-down"
            size={12}
          />
        </div>
      </ListboxArrow>
    </ListboxButton>
  )
}

export default Button
